export default "__VITE_ASSET__BgAAgr3L__"